import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './app/routes';
import { AdminAuthProvider } from './lib/AdminAuthProvider';
import { RegionProvider } from './lib/RegionProvider';
import { initTheme } from '@shared/theme';

// Kendo Fluent base theme → shared --kendo-* mapping → admin slate/indigo
// brand override. Order is load-bearing (each layer's :root must beat the
// previous). See src/frontend/admin/src/theme/admin-overrides.css.
import '@progress/kendo-theme-fluent/dist/all.css';
import '@shared/theme/index.css';
import './theme/admin-overrides.css';
import './index.css';

// Admin runs light-only for now; the slate palette only defines light values.
initTheme('light');

// KendoReact licensing is activated at build time via `npx kendo-ui-license
// activate` (TELERIK_LICENSE), which bakes the key into @progress/kendo-licensing.
// No runtime activation call is needed. See docs/architecture.md (Phase 5).

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <RegionProvider>
      <AdminAuthProvider>
        <RouterProvider router={router} />
      </AdminAuthProvider>
    </RegionProvider>
  </StrictMode>,
);
